import { IntlShape } from "react-intl";

import ForecastViewMode from "@app/scene/deal/component/ForecastPage/enum/ForecastViewMode";

const useNameDateFormat = (forecastViewMode: ForecastViewMode, intl: IntlShape) =>
  forecastViewMode === ForecastViewMode.MONTH
    ? intl.formatMessage({
        id: "deals.forecastView.column.name.byMonth",
        defaultMessage: "MMMM yyyy",
        description: "Forecast view's column name format for month view mode",
      })
    : intl.formatMessage({
        id: "deals.forecastView.column.name.byQuarter",
        defaultMessage: "qqq yyyy",
        description: "Forecast view's column name format for quarter view mode",
      });

export default useNameDateFormat;
